/* unplugin-vue-components disabled */import { render } from "./CopySpeach.vue?vue&type=template&id=20f0e79c&scoped=true&ts=true"
import script from "./CopySpeach.vue?vue&type=script&lang=ts"
export * from "./CopySpeach.vue?vue&type=script&lang=ts"

import "./CopySpeach.vue?vue&type=style&index=0&id=20f0e79c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f0e79c"]])

export default __exports__